module.exports = __webpack_public_path__ + "static/media/ml.a5e8380b.gif";